define('commons/waterfall',['jquery', 'commons/loading-mask', 'commons/message-manager', 'utils/colors', 'utils/base64', 'commons/availability-analyser'], function($, LoadingMask, messages, colors,
        base64, Availability) {

    function Waterfall(canvas, toolLayer, options) {

        this.$canvas = $(canvas);
        this.canvas = this.$canvas[0];
        this.$toolLayer = $(toolLayer);
        this.toolLayer = this.$toolLayer[0];
        this.$parent = this.$canvas.parent();
        this.loadingMask = new LoadingMask(this.$parent, {
            maskColor: '#000',
            iconColor: 'white'
        });

        this.ctx = this.canvas.getContext('2d');
        this.toolLayerCtx = this.toolLayer.getContext('2d');

        isSelecting = false;
        // trigger a refresh on start
        viewportHasChanged = true;

        this.iMin = 0;
        this.iMax = 0;
        this.dataLength = 0;
        this.refresh = true;

        this.protocol = "waterfall";

        this.minSize = 50;

        this.options = $.extend(true, {
            tapHexId: "",
            lineColor: "#FFF",
            tapBaseFrequency: 0,
            macroChannel: 0,
            mastEquipmentGain: 0,
            cableLoss: 0,
            minDb: 0,
            maxDb: 0,
            color: "hsb",
            minColor: {
                rgb: [0, 0, 0],
                hsb: [0, 0, 0]
            },
            maxColor: {
                rgb: [0, 0, 0],
                hsb: [0, 0, 0]
            },
            height: 200,
            autoResize: true,
            autoStart: false,
            isPsdr: false,
            isCorrectionNeeded: true,
            isBitRate600: false,
            internalAllowed: false,
            psdrFilter100: 330,
            psdrFilter600: 794,
            sensitivityDegradation: 0
        }, options);

        // X offset so that we can display the scale properly
        this.scaleXOffset = 37;

        // VIP address
        this.routeUrl = this.options.backendAddress + "/ws/route/";

        // Compute min/max Freq values
        this.minFrequency = this.options.tapBaseFrequency - this.options.macroChannel / 2;
        this.maxFrequency = this.options.tapBaseFrequency + this.options.macroChannel / 2;

        // Save default dB values so that we could reset these later
        this.defaultValues = {
            db: {
                min: this.options.minDb,
                max: this.options.maxDb
            },
            freq: {
                min: this.minFrequency,
                max: this.maxFrequency
            }
        };

        this.routeUrl += this.options.tapHexId;

        // Init hsb colors
        if (this.options.color == "rgb") {
            var minHsb = colors.RGBToHSB(this.options.minColor.rgb[0], this.options.minColor.rgb[1], this.options.minColor.rgb[2]);
            this.options.minColor.hsb = [minHsb.h, minHsb.s, minHsb.b];
            var maxHsb = colors.RGBToHSB(this.options.maxColor.rgb[0], this.options.maxColor.rgb[1], this.options.maxColor.rgb[2]);
            this.options.maxColor.hsb = [maxHsb.h, maxHsb.s, maxHsb.b];
        }

        this.canvas.height = Math.max(this.minSize, this.options.height);
        this.canvas.width = Math.max(this.minSize, this.canvas.width);

        this.toolLayer.height = Math.max(this.minSize, this.options.height);
        this.toolLayer.width = Math.max(this.minSize, this.toolLayer.width);

        var defaultSpaceHeight = 30;
        this.space = {
            top: (this.canvas.height / 2) - defaultSpaceHeight / 2,
            height: defaultSpaceHeight
        };

        this.dim = {
            spectrum: {
                top: 0,
                height: this.space.top
            },
            waterfall: {
                top: this.space.top + this.space.height,
                height: this.canvas.height - this.space.top - this.space.height
            }
        };

        var $window = $(window);
        $window.unload($.proxy(function() {
            this.stop();
        }, this));

        // Set the default fill color
        this.ctx.fillStyle = "rgb(0,0,0)";

        if (this.options.autoResize) {
            $window.bind("orientationchange", $.proxy(function(event) {
                this.onResize();
            }, this));

            $window.bind("resize", $.proxy(function() {
                this.onResize();
            }, this));
        }
        this.onResize();
        
        var avOptions = {};
        if (this.options.isBitRate600) {
            avOptions = {
                    spectUnderSpl : 4,
                    dt: 0.066,
                    sensitivityDegradation : this.options.sensitivityDegradation,
                    frameTime: 0.35,
                    availOffset: -10 * Math.log10(this.options.psdrFilter600) + 10 * Math.log10(600)
            };
        } else {
            avOptions = {
                    spectUnderSpl : 2,
                    dt: 0.2,
                    sensitivityDegradation : this.options.sensitivityDegradation,
                    frameTime: 2.08,
                    availOffset: -10 * Math.log10(this.options.psdrFilter100) + 10 * Math.log10(100)
            };
        }
        if (this.options.internalAllowed) {
            this.availability = new Availability(avOptions);
        }

        if (this.options.autoStart) {
            this.start();
        }
        
        this.refreshRate = this.options.isBitRate600 ? 15 : 5;
    };

    Waterfall.prototype.onResize = function() {
        // Check canvas
        this.canvas.width = Math.max(this.minSize, this.$parent.width());
        this.toolLayer.width = Math.max(this.minSize, this.$parent.width());
        // Redraw the background
        this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);

        this.toolLayerCtx.strokeStyle = "#00CCFF";
    };

    Waterfall.prototype.stop = function() {
        if (this.ws) {
            this.ws.close();
            clearTimeout(this.timer);
            this.loadingMask.hide();
        }
    };

    Waterfall.prototype.start = function() {
        this.loadingMask.show();
        this.connect(this.routeUrl);
    };

    Waterfall.prototype.connect = function(routeUrl) {
        if (!this.ws) {
            $.ajax({
                url: routeUrl,
                success: function(data) {
                    var isSecure = ("https:" == location.protocol);
                    var url = (isSecure ? "wss://" : "ws://") + data.host + ":" + (isSecure ? data.portSsl : data.port) + "/ws/connect/" +
                            this.options.tapHexId;
                    url += "?" + data.cookieKey + "=" + data.cookieValue;
                    this.ws = new WebSocket(url, this.protocol);
                    this.ws.onopen = $.proxy(this.onWsOpen, this);
                    this.ws.onmessage = $.proxy(this.onWsMessage, this);
                    this.ws.onclose = $.proxy(this.onWsClose, this);
                    this.ws.onerror = $.proxy(this.onWsError, this);
                },
                error: function(event, jqXHR) {
                    messages.error("An error has occurred, try again in 5s");
                    this.reConnect(5000);
                },
                context: this,
                cache: false,
                dataType: "json",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                }
            });
        }
    };

    Waterfall.prototype.onWsOpen = function() {
        this.ctx.fillRect(this.scaleXOffset, 0, this.canvas.width - this.scaleXOffset, this.canvas.height);
    };

    Waterfall.prototype.onWsMessage = function(message) {
        if (message.data && message.data.length > 0) {
            clearTimeout(this.timer);
            this.loadingMask.hide();
            this.timer = setTimeout($.proxy(function() {
                this.loadingMask.show();
            }, this), 2000);
            var data = base64.decode64(message.data);
            this.draw(data);
        }
    };

    Waterfall.prototype.onWsClose = function(event) {
        this.ws = null;
        if (this.refresh) {
            this.reConnect(5000);
        }
    };

    Waterfall.prototype.onWsError = function(event) {
        messages.error("An error has occurred, try again in 5s");
    };

    Waterfall.prototype.reConnect = function(delay) {
        // Try to reconnect
        window.setTimeout($.proxy(function() {
            this.connect(this.routeUrl);
        }, this), delay);
    };

    Waterfall.prototype.draw = function(data) {
        var rawData = null;
        var correctedData = data;
        if (data === null) {
            rawData = this.ctx.createImageData(this.canvas.width - this.scaleXOffset, 1);
            this.ctx.fillRect(this.scaleXOffset, this.dim.spectrum.top, this.canvas.width - this.scaleXOffset, this.dim.spectrum.height);
        } else {
            correctedData = this._correctData(data);
            rawData = this._processData(correctedData);
        }
        
        // availability
        if (this.options.internalAllowed) {
            this.availability.process(correctedData);
        }
        
        // waterfall
        var raw = this.ctx.getImageData(this.scaleXOffset, this.dim.waterfall.top, this.canvas.width - this.scaleXOffset, this.dim.waterfall.height);
        this.ctx.putImageData(raw, this.scaleXOffset, this.dim.waterfall.top + 1);
        this.ctx.putImageData(rawData, this.scaleXOffset, this.dim.waterfall.top);
    };
    
    Waterfall.prototype._correctData = function(data) {
        var result = [];
        for (var i = 0; i < data.length; i++) {
            var value = null;
            // Dirty rollback
            if (this.options.isPsdr) {
                value = -data[i];
            } else {
                value = data[i];
            }
            if (this.options.isCorrectionNeeded){
                value += this.options.cableLoss - this.options.mastEquipmentGain;
            }
            result[i] = value;
        }
        return result;
    }

    /**
     * In the raw data, pixels are stored as following: [r, g, b, a, r, g, b ,a, ...] --pixel 1-- --pixel 2--
     * 
     */
    Waterfall.prototype._processData = function(data) {
        var tmp = [];
        var w = this.canvas.width - this.scaleXOffset;

        // Compute indexes depending on min/max Freq.
        if (viewportHasChanged) {
            this.iMin = this._frequencyToTabIndex(this.minFrequency, data.length);
            this.iMax = this._frequencyToTabIndex(this.maxFrequency, data.length);
            this.dataLength = this.iMax - this.iMin + 1;

            // Update min/max freq, indeed we display the entire indexes values so we need to compute correct freq
            this.minFrequency = this._tabIndexToFrequency(this.iMin, data.length, false);
            this.maxFrequency = this._tabIndexToFrequency(this.iMax, data.length, true);

            viewportHasChanged = false;
        }

        var iter = Math.max(w, this.dataLength);
        for (var i = 0; i < iter; i++) {
            var toIndex = Math.floor(i * w / iter);
            var fromIndex = Math.floor(i * this.dataLength / iter) + this.iMin;
            var value = data[fromIndex];
            if (this.options.isPsdr) {
                value = Math.pow(10, value / 10);
            }
            var oldValue = (tmp[toIndex] ? tmp[toIndex].v : 0);
            var c = (tmp[toIndex] ? tmp[toIndex].c : 0);
            tmp[toIndex] = {
                v: (oldValue * c + value) / (c + 1),
                c: c + 1
            };
        }
        // Create raw data
        var rawData = this.ctx.createImageData(tmp.length, 1);
        var range = this.options.maxDb - this.options.minDb;
        var from = this.dim.spectrum.top + this.dim.spectrum.height;

        // ----------------------------------
        // DATA DRAWING
        // ----------------------------------

        this.ctx.beginPath();
        this.ctx.strokeStyle = this.options.lineColor;
        this.ctx.fillRect(0, this.dim.spectrum.top, this.canvas.width, this.dim.spectrum.height + 14);
        // clean waterfall scale
        this.ctx.fillRect(0, this.dim.waterfall.top, this.scaleXOffset, this.dim.waterfall.height);

        for (var j = 0; j < tmp.length; j++) {
            var v = null;
            // Dirty rollback
            if (this.options.isPsdr) {
                v = 10 * Math.log(tmp[j].v) / Math.LN10;
            } else {
                v = -tmp[j].v;
            }
            var rgb = this.gradient(v);
            // this.ctx.moveTo(j, from);

            // TODO see if you should keep the fakes top lines, for now we've removed it
            // this.ctx.lineTo(j+this.scaleXOffset, Math.max(0, Math.min(from, from - (v - this.options.minDb) * this.dim.spectrum.height / range)));
            this.ctx.lineTo(j + this.scaleXOffset, Math.min(from, from - (v - this.options.minDb) * this.dim.spectrum.height / range));
            var index = j * 4;
            rawData.data[index] = rgb.r;
            rawData.data[index + 1] = rgb.g;
            rawData.data[index + 2] = rgb.b;
            // transparency
            rawData.data[index + 3] = 255;
        }

        // ----------------------------------
        // SCALES DRAWING
        // ----------------------------------
        var timeForQuarter = this._timeForLines(this.dim.waterfall.height / 4);
        // vertical scale (Waterfall)
        this._buildScale(this.ctx,
        // Coords
        {
            xmin: this.scaleXOffset - 2,
            xmax: this.scaleXOffset,
            ymin: this.dim.waterfall.top,
            ymax: this.canvas.height
        },
        // Labels
        [{
            text: 0,
            x: 1,
            y: this.dim.waterfall.top
        }, {
            text: timeForQuarter,
            x: 1,
            y: this.dim.waterfall.top + this.dim.waterfall.height / 4,
            baseline: "middle"
        }, {
            text: 2 * timeForQuarter,
            x: 1,
            y: this.dim.waterfall.top + this.dim.waterfall.height / 2,
            baseline: "middle"
        }, {
            text: 3 * timeForQuarter,
            x: 1,
            y: this.dim.waterfall.top + 3 * this.dim.waterfall.height / 4,
            baseline: "middle"
        }]);

        // little lines
        for (var yPos = this.dim.waterfall.top; yPos < this.dim.waterfall.top + this.dim.waterfall.height; yPos += this.dim.waterfall.height / 4) {
            this._drawLine(this.ctx, this.scaleXOffset, yPos, this.scaleXOffset - 10, yPos);
        }

        // vertical scale (Signal)
        this._buildScale(this.ctx,
        // Coords
        {
            xmin: this.scaleXOffset,
            xmax: this.scaleXOffset,
            ymin: 0,
            ymax: this.dim.spectrum.height
        },
        // Labels
        [{
            text: this.options.minDb,
            x: 1,
            y: this.dim.spectrum.height - 12
        }, {
            text: (this.options.maxDb - this.options.minDb) / 2 + this.options.minDb,
            x: 1,
            y: this.dim.spectrum.height / 2,
            baseline: "middle"
        }, {
            text: this.options.maxDb,
            x: 1,
            y: 0
        }]);

        // Compute maxValue text length
        var horizontalMaxValue = this.maxFrequency;
        var horizontalMidValue = this.minFrequency + (horizontalMaxValue - this.minFrequency) / 2;
        var hMaxValueWidth = this.ctx.measureText(horizontalMaxValue).width;
        var hMiddleValueWidth = this.ctx.measureText(horizontalMidValue).width;

        // hozitontal scale (Frequency)
        this._buildScale(this.ctx,
        // Coords
        {
            xmin: this.scaleXOffset,
            xmax: this.canvas.width,
            ymin: this.dim.spectrum.height,
            ymax: this.dim.spectrum.height
        },
        // Labels
        [{
            text: this.minFrequency,
            x: this.scaleXOffset,
            y: this.dim.spectrum.height
        }, {
            text: horizontalMidValue,
            x: (this.canvas.width - this.scaleXOffset) / 2 + this.scaleXOffset - hMiddleValueWidth / 2,
            y: this.dim.spectrum.height
        }, {
            text: horizontalMaxValue,
            x: this.canvas.width - hMaxValueWidth,
            y: this.dim.spectrum.height
        }],
        // precision
        3);

        this.ctx.stroke();

        return rawData;
    };

    /**
     * @param value:
     *            the dbm value
     * @return the corresponding rgb value
     */
    Waterfall.prototype.gradient = function(value) {
        var hsb = [];
        for (var i = 0; i < 3; i++) {
            hsb[i] = this.options.minColor.hsb[i] + Math.min(1, (value - this.options.minDb) / (this.options.maxDb - this.options.minDb)) *
                    (this.options.maxColor.hsb[i] - this.options.minColor.hsb[i]);
        }
        return colors.HSBToRGB(hsb[0], hsb[1], hsb[2]);
    };

    /**
     * Tool Box : creates a scale, manages zoomIn/Out, pan, details.
     */

    // ////////////////////////////////////
    // DETAILS MODE //
    // ////////////////////////////////////
    /**
     * Enable/Disable the details mode. - enable: Boolean, true if you wan't to enable the Details mode, false otherwise.
     */
    Waterfall.prototype.enableDetailsMode = function(enable) {
        if (enable) {
            // disable other modes
            this.enableZoomMode(false);
            this.enablePanMode(false);

            this.toolLayer.style.cursor = "crosshair";
            // Track mouse movement
            this.$toolLayer.mousemove($.proxy(this._mouseMoveDetailsListener, this));
            this.$toolLayer.mouseout($.proxy(this._mouseOutDetailsListener, this));
        } else {
            this.toolLayer.style.cursor = "default";
            $("#details-box").fadeOut('fast');
            this.$toolLayer.unbind('mousemove', this._mouseMoveDetailsListener);
        }
    };

    Waterfall.prototype._mouseOutDetailsListener = function(e) {
        $("#details-box").fadeOut('fast');
    };

    Waterfall.prototype._mouseMoveDetailsListener = function(e) {
        var x = this._multiBrowserOffsetX(e);
        var y = this._multiBrowserOffsetY(e);
        // Check out of bounds
        if (x < this.scaleXOffset || y > this.dim.spectrum.height) {
            $("#details-box").fadeOut('fast');
        } else {
            var values = this._pointsToValues(x, y);
            var detail = $("#details-box");
            detail.text(values.mHzValue.toFixed(3) + ' MHz, ' + values.dBValue.toFixed(2) + ' dBm');
            if (x > this.canvas.offsetWidth / 2) {
                x = x - detail[0].offsetWidth - 10;
            } else {
                x = x + 10;
            }
            detail.css({
                top: (y + 10) + "px",
                left: x + "px"
            }).fadeIn();
        }
    };

    // ////////////////////////////////////
    // ZOOM MODE //
    // ////////////////////////////////////
    /**
     * Enable/Disable the zoom mode. - enable: Boolean, true if you wan't to enable the Details mode, false otherwise. - zoomType: ZoomTypeEnum,
     * describes the zoom type. Can be HORIZONTAL, VERTICAL, or MANUAL.
     * 
     * @see ZoomTypeEnum
     */
    Waterfall.prototype.enableZoomMode = function(enable, zoomType) {
        if (enable) {
            // disable other modes
            this.enableDetailsMode(false);
            this.enablePanMode(false);

            switch (zoomType) {
                case ZoomTypeEnum.HORIZONTAL:
                    this.toolLayer.style.cursor = "col-resize";
                    break;
                case ZoomTypeEnum.VERTICAL:
                    this.toolLayer.style.cursor = "row-resize";
                    break;
                case ZoomTypeEnum.MANUAL:
                    this.toolLayer.style.cursor = "crosshair";
                    break;
                default:
                    throw "Unhandled zoom type, please add a specific case for this value.";
            }

            // Track mouse actions
            this.$toolLayer.mousedown($.proxy(this._mouseDownZoomListener, this, zoomType));
            this.$toolLayer.mouseup($.proxy(this._mouseUpZoomListener, this, zoomType));
            this.$toolLayer.mousemove($.proxy(this._mouseMoveZoomListener, this, zoomType));
        } else {
            this.toolLayer.style.cursor = "default";
            this.$toolLayer.unbind('mousedown', this._mouseDownZoomListener);
            this.$toolLayer.unbind('mouseup', this._mouseUpZoomListener);
            this.$toolLayer.unbind('mousemove', this._mouseMoveZoomListener);
        }
    };

    Waterfall.prototype._mouseDownZoomListener = function(zoomType, e) {
        var x = (this._multiBrowserOffsetX(e) > this.scaleXOffset) ? this._multiBrowserOffsetX(e) : this.scaleXOffset;
        var y = (this._multiBrowserOffsetY(e) < this.dim.spectrum.height) ? this._multiBrowserOffsetY(e) : this.dim.spectrum.height;

        if (x <= this.scaleXOffset || y >= this.dim.spectrum.height) {
            return false;
        }

        // Clear the layer
        this.toolLayerCtx.clearRect(0, 0, this.toolLayer.width, this.toolLayer.height);

        // global vars
        // If the zoom is VERTICAL we don't care about real x position
        startX = (zoomType == ZoomTypeEnum.VERTICAL) ? this.scaleXOffset : x;
        startY = (zoomType == ZoomTypeEnum.HORIZONTAL) ? 0 : y;
        isSelecting = true;

        if (zoomType == ZoomTypeEnum.VERTICAL) {
            this.toolLayerCtx.beginPath();
            this._drawLine(this.ctx, startX, startY, this.toolLayer.width, startY);
            this.toolLayerCtx.stroke();
        } else if (zoomType == ZoomTypeEnum.HORIZONTAL) {
            this.toolLayerCtx.beginPath();
            this._drawLine(this.ctx, startX, startY, startX, this.dim.spectrum.height);
            this.toolLayerCtx.stroke();
        }

        return false;
    };

    Waterfall.prototype._mouseUpZoomListener = function(zoomType, e) {
        if (isSelecting) {
            var x = (this._multiBrowserOffsetX(e) > this.scaleXOffset) ? this._multiBrowserOffsetX(e) : this.scaleXOffset;
            var y = (this._multiBrowserOffsetY(e) < this.dim.spectrum.height) ? this._multiBrowserOffsetY(e) : this.dim.spectrum.height;

            isSelecting = false;

            // Clear the layer
            this.toolLayerCtx.clearRect(0, 0, this.toolLayer.width, this.toolLayer.height);

            // Manage zoom
            switch (zoomType) {
                case ZoomTypeEnum.HORIZONTAL:
                    var startFreqValue = this._pointsToValues(startX, startY).mHzValue;
                    var finalFreqValue = this._pointsToValues(x, y).mHzValue;

                    this.minFrequency = Math.min(startFreqValue, finalFreqValue);
                    this.maxFrequency = Math.max(startFreqValue, finalFreqValue);
                    break;
                case ZoomTypeEnum.VERTICAL:
                    var startDbValue = this._pointsToValues(startX, startY).dBValue;
                    var finalDbValue = this._pointsToValues(x, y).dBValue;

                    this.options.minDb = Math.min(startDbValue, finalDbValue);
                    this.options.maxDb = Math.max(startDbValue, finalDbValue);
                    break;
                case ZoomTypeEnum.MANUAL:
                    var startFreqValue = this._pointsToValues(startX, startY).mHzValue;
                    var finalFreqValue = this._pointsToValues(x, y).mHzValue;
                    var startDbValue = this._pointsToValues(startX, startY).dBValue;
                    var finalDbValue = this._pointsToValues(x, y).dBValue;

                    this.options.minDb = Math.min(startDbValue, finalDbValue);
                    this.options.maxDb = Math.max(startDbValue, finalDbValue);
                    this.minFrequency = Math.min(startFreqValue, finalFreqValue);
                    this.maxFrequency = Math.max(startFreqValue, finalFreqValue);
                    break;
                default:
                    throw "Unhandled zoom type, please add a specific case for this value.";
            }

            viewportHasChanged = true;
        }
    };

    Waterfall.prototype._mouseMoveZoomListener = function(zoomType, e) {
        if (isSelecting) {
            // Clear the layer
            this.toolLayerCtx.clearRect(0, 0, this.toolLayer.width, this.toolLayer.height);

            var x = (this._multiBrowserOffsetX(e) > this.scaleXOffset) ? this._multiBrowserOffsetX(e) : this.scaleXOffset;
            var y = (this._multiBrowserOffsetY(e) < this.dim.spectrum.height) ? this._multiBrowserOffsetY(e) : this.dim.spectrum.height;

            var width = (zoomType == ZoomTypeEnum.VERTICAL) ? this.toolLayer.width : x - startX;
            var height = (zoomType == ZoomTypeEnum.HORIZONTAL) ? this.dim.spectrum.height : y - startY;

            this.toolLayerCtx.beginPath();
            this.toolLayerCtx.globalAlpha = 0.3;
            this.toolLayerCtx.rect(startX, startY, width, height);
            this.toolLayerCtx.fillStyle = this.toolLayerCtx.strokeStyle;
            this.toolLayerCtx.fill();
            this.toolLayerCtx.stroke();
        }
    };

    // ////////////////////////////////////
    // PAN MODE //
    // ////////////////////////////////////

    /**
     * Enable/Disable the pan mode. - enable: Boolean, true if you wan't to enable the Pan mode, false otherwise.
     */
    Waterfall.prototype.enablePanMode = function(enable) {
        if (enable) {
            // disable other modes
            this.enableZoomMode(false);
            this.enableDetailsMode(false);

            this.toolLayer.style.cursor = "move";
            // Track mouse actions
            this.$toolLayer.mousedown($.proxy(this._mouseDownPanListener, this));
            this.$toolLayer.mouseup($.proxy(this._mouseUpPanListener, this));
            this.$toolLayer.mousemove($.proxy(this._mouseMovePanListener, this));
        } else {
            this.toolLayer.style.cursor = "default";
            this.$toolLayer.unbind('mousedown', this._mouseDownPanListener);
            this.$toolLayer.unbind('mouseup', this._mouseUpPanListener);
            this.$toolLayer.unbind('mousemove', this._mouseMovePanListener);
        }
    };

    Waterfall.prototype._mouseDownPanListener = function(e) {
        startX = (this._multiBrowserOffsetX(e) > this.scaleXOffset) ? this._multiBrowserOffsetX(e) : this.scaleXOffset;
        startY = (this._multiBrowserOffsetY(e) < this.dim.spectrum.height) ? this._multiBrowserOffsetY(e) : this.dim.spectrum.height;

        isSelecting = true;

        return false;
    };

    Waterfall.prototype._mouseUpPanListener = function(e) {
        isSelecting = false;
    };

    Waterfall.prototype._mouseMovePanListener = function(e) {
        if (isSelecting) {
            var x = (this._multiBrowserOffsetX(e) > this.scaleXOffset) ? this._multiBrowserOffsetX(e) : this.scaleXOffset;
            var y = (this._multiBrowserOffsetY(e) < this.dim.spectrum.height) ? this._multiBrowserOffsetY(e) : this.dim.spectrum.height;

            var startPointValues = this._pointsToValues(startX, startY);
            var finalPointValues = this._pointsToValues(x, y);

            // Volontary inverted to offer better UX during the pan
            // The pan is more logical when you "grab and pull" the screen
            var mHzOffset = startPointValues.mHzValue - finalPointValues.mHzValue;
            var dBOffset = startPointValues.dBValue - finalPointValues.dBValue;

            var viewHasChanged = false;

            // Y axis
            this.options.minDb += dBOffset;
            this.options.maxDb += dBOffset;
            viewHasChanged = true;

            // X axis
            if (this.minFrequency + mHzOffset >= this.defaultValues.freq.min && this.maxFrequency + mHzOffset <= this.defaultValues.freq.max) {
                this.minFrequency += mHzOffset;
                this.maxFrequency += mHzOffset;
                viewHasChanged = true;
            }

            startX = x;
            startY = y;
            viewportHasChanged = viewHasChanged;
        }
    };

    // ////////////////////////////////////
    // UTILS //
    // ////////////////////////////////////

    /**
     * Enum used to describe the zoom type
     */
    ZoomTypeEnum = {
        HORIZONTAL: 0,
        VERTICAL: 1,
        MANUAL: 2
    };

    /**
     * Build a scale depending on the arguments. Usage: ctx: context2d from canvas coords:{xmin:0, xmax:0, ymin:0, ymax:100}
     * labels:[{text:"blabla",x:0, y:0, baseline: "top"}] , baseline is optionnal and default is "top". precision : The decimal numbers you need to
     * display, default is 0
     */
    Waterfall.prototype._buildScale = function(ctx, coords, labels, precision) {
        precision = precision || 0;

        // Draw the line
        this._drawLine(ctx, coords.xmin, coords.ymin, coords.xmax, coords.ymax);

        // Remember the current fill style, if you're asking why see below ;)
        var oldFillStyle = ctx.fillStyle;
        ctx.fillStyle = ctx.strokeStyle;
        ctx.font = "10pt Arial";

        var here = this;
        // Draw texts
        $.each(labels, function(i, label) {
            ctx.textBaseline = label.baseline || "top";
            here.ctx.fillText(label.text.toFixed(precision), label.x, label.y);
        });

        // re set the oldFillStyle to avoid background color changes for future displays.
        ctx.fillStyle = oldFillStyle;
    };

    /**
     * Pretty straight...
     */
    Waterfall.prototype._drawLine = function(ctx, xmin, ymin, xmax, ymax) {
        ctx.moveTo(xmin, ymin);
        ctx.lineTo(xmax, ymax);
    };

    /**
     * Converts a spectrum relative mouse coordinate (x,y) into its value in (dB,MHz) Returns : {mHzValue:868.58, dBValue:-50};
     */
    Waterfall.prototype._pointsToValues = function(x, y) {
        // Value in MHz
        var mHzValue = this.minFrequency + (this.maxFrequency - this.minFrequency) / (this.canvas.width - this.scaleXOffset) *
                (x - this.scaleXOffset);
        // Value in dB
        var dBValue = this.options.minDb + ((this.options.maxDb - this.options.minDb) / this.dim.spectrum.height) * (this.dim.spectrum.height - y);

        return {
            mHzValue: mHzValue,
            dBValue: dBValue
        };
    };

    /**
     * Converts a spectrum value (MHz, dB) into a mouse coordinate (x,y) Returns : {x:200 , y:50};
     */
    Waterfall.prototype._valuesToPoint = function(mHzValue, dBValue) {
        var x = ((mHzValue - this.minFrequency) / (this.maxFrequency - this.minFrequency)) * (this.canvas.width - this.scaleXOffset);
        var y = ((dBValue - this.options.minDb) / (this.options.maxDb - this.options.minDb)) * (this.dim.spectrum.height) + this.dim.spectrum.height;

        return {
            x: x,
            y: y
        };
    };

    /**
     * Convert the given Frequency € [minFrequency; maxFrequency] into a data tab index.
     */
    Waterfall.prototype._frequencyToTabIndex = function(frequency, tabLength) {
        var index = Math.floor(((frequency - this.defaultValues.freq.min) * (tabLength)) /
                (this.defaultValues.freq.max - this.defaultValues.freq.min));
        // Ensure no OutOfBounds
        return Math.min(index, tabLength - 1);
    };

    /**
     * Convert the given data tab index into the corresponding Frequency. Params : - isInclusive : true if you wan't to include the tabIndex frequency
     * range.
     */
    Waterfall.prototype._tabIndexToFrequency = function(tabIndex, tabLength, isInclusive) {
        var offset = isInclusive ? (this.defaultValues.freq.max - this.defaultValues.freq.min) / tabLength : 0;

        return ((tabIndex * (this.defaultValues.freq.max - this.defaultValues.freq.min)) / tabLength) + this.defaultValues.freq.min + offset;
    };

    /**
     * Returns the number of seconds represented by the given lines number.
     */
    Waterfall.prototype._timeForLines = function(linesNb) {
        return Math.round(linesNb / this.refreshRate);
    };

    /**
     * Sets all axis to default values : db => minDb, maxDb. freq => minFrequency, maxFrequency
     */
    Waterfall.prototype.setToDefaults = function() {
        this.minFrequency = this.defaultValues.freq.min;
        this.maxFrequency = this.defaultValues.freq.max;

        this.options.minDb = this.defaultValues.db.min;
        this.options.maxDb = this.defaultValues.db.max;

        this.enableDetailsMode(false);
        this.enableZoomMode(false);
        this.enablePanMode(false);

        viewportHasChanged = true;
    };

    /**
     * Change base frequency of the waterfall
     */
    Waterfall.prototype.setBaseFrequency = function(baseFreq) {
        this.defaultValues.freq.min = (baseFreq / 1000000) - this.options.macroChannel / 2;
        this.defaultValues.freq.max = (baseFreq / 1000000) + this.options.macroChannel / 2;
        this.maxFrequency = this.defaultValues.freq.max;
        this.minFrequency = this.defaultValues.freq.min;
    };

    /**
     * Fix for the jQuery offsetX bug on FireFox;
     */
    Waterfall.prototype._multiBrowserOffsetX = function(e) {
        return (e.offsetX || e.pageX - $(e.target).offset().left);
    };

    /**
     * Fix for the jQuery offsetY bug on FireFox;
     */
    Waterfall.prototype._multiBrowserOffsetY = function(e) {
        return (e.offsetY || e.pageY - $(e.target).offset().top);
    };

    Waterfall.prototype.reloadAvailability = function() {
        this.availability.reload();
    };

    return Waterfall;
    
});
